"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import smoothscroll from "smoothscroll-polyfill";
import "pace-progressbar";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

const mediaQuery = matchMedia("screen and (min-width: 768px)");
changeMediaQuery(mediaQuery);
// ウィンドウサイズが変更されても実行されるように
mediaQuery.addListener(changeMediaQuery);

/**
 * header
 */
var windowHeight,
  header,
  headerHeight,
  headerMenu,
  glonav,
  glonavHeight,
  headerBlock;

function changeMediaQuery(mq) {
  if (mq.matches) {
    // PC
    document.body.classList.add("is-pc");
    document.body.classList.remove("is-sp");
    // グロナビ外をクリックしたら閉じる
    document
      .querySelector(".header-list__blank")
      .addEventListener("click", (e) => {
        document.querySelector(".js-header").classList.remove("is-active");
        document.querySelector(".js-header-btn").classList.toggle("is-active");
        scrollLock();
      });
  } else {
    // SP
    document.body.classList.add("is-sp");
    document.body.classList.remove("is-pc");
    // kv
    // スクロールするとvhが変わってしまう問題を解決
    changeKvHeight();
    window.addEventListener("resize", changeKvHeight);
  }

  windowHeight = window.innerHeight;
  header = document.querySelector(".header__inner");
  headerHeight = header.clientHeight;
  headerMenu = document.querySelector(".header-list__inner");
  glonav = document.querySelector(".header-list__item");
  glonavHeight = glonav.clientHeight;
  headerBlock = document.querySelector(".header-list__blc");

  // header
  if (windowHeight - headerHeight <= glonavHeight) {
    headerBlock.classList.add("scroll");
  }
  headerMenu.style.height = windowHeight + "px";
  headerBlock.style.height = windowHeight - headerHeight + "px";
}

window.addEventListener("resize", function () {
  windowHeight = window.innerHeight;
  headerHeight = header.clientHeight;
  glonavHeight = glonav.clientHeight;
  // header
  if (windowHeight - headerHeight <= glonavHeight) {
    headerBlock.classList.add("scroll");
  } else {
    if (headerBlock.classList.contains("scroll"))
      headerBlock.classList.remove("scroll");
  }
  headerMenu.style.height = windowHeight + "px";
  headerBlock.style.height = windowHeight - headerHeight + "px";
});

// グロナビ 展開
document.querySelectorAll(".js-header-btn").forEach((target) => {
  target.addEventListener("click", (e) => {
    const thisBtn = e.currentTarget;
    thisBtn.classList.toggle("is-active");
    document.querySelector(".js-header").classList.toggle("is-active");
    scrollLock();
  });
});
//グロナビ押したら閉じる
document.querySelectorAll(".glonav-menu__link").forEach((target) => {
  target.addEventListener("click", (e) => {
    document.querySelector(".js-header").classList.remove("is-active");
    document.querySelector(".js-header-btn").classList.toggle("is-active");
    scrollLock();
  });
});

let scrollY;

function scrollLock() {
  if (document.body.classList.contains("is-scroll-locked")) {
    document.body.style.top = "";
    document.body.classList.remove("is-scroll-locked");
    window.scrollTo(0, scrollY);
    return false;
  }

  scrollY = document.documentElement.scrollTop || document.body.scrollTop;

  // メニューを開いたときにスクロール位置が一番上に戻らないように
  document.body.style.top = `-${scrollY}px`;
  document.body.classList.add("is-scroll-locked");
}

function changeKvHeight() {
  document.querySelectorAll(".js-height").forEach((target) => {
    target.style.height = `${window.outerHeight}px`;
  });
}

// スムーススクロール
smoothscroll.polyfill();

document.querySelectorAll(`a[href*="#"]`).forEach((link) => {
  link.addEventListener("click", (e) => {
    const target = e.currentTarget;
    e.preventDefault();

    const targetId = target.hash;
    var href = target.href;
    var param = href.substring(href.indexOf("?"));
    if (href.indexOf("?") > -1) {
      location.href = href.replace(param, "");
    } else {
      const targetElement = document.querySelector(targetId);
      // 画面上部から要素までの距離
      const rectTop = targetElement.getBoundingClientRect().top;
      // 現在のスクロール距離
      const offsetTop = window.pageYOffset;
      //スクロール位置に持たせるバッファ
      const top = rectTop + offsetTop;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }
  });
});

/**
 * スクロールイベント登録
 */
window.addEventListener(
  "scroll",
  function () {
    changeHeaderStyle();
  },
  false
);

/**
 * KV(.kvの要素)以下はheaderのデザイン変更
 */
var header = document.querySelector(".header__inner");
var kv = document.querySelector(".kv");
var scrollStart = kv.clientHeight;
function changeHeaderStyle() {
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollStart <= scrollTop) {
    header.classList.add("fixed");
  } else if (scrollStart >= scrollTop) {
    header.classList.remove("fixed");
  }
}

// IEでスムーススクロールを無効に
if (document.documentMode) {
  document.querySelector(`body`).addEventListener("mousewheel", (event) => {
    event.preventDefault();
    let wd = event.wheelDelta;
    let csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
  });
}

var element = document.querySelector(".header-visit");
element.addEventListener("click", function () {
  var target = new gsap.timeline();
  target
    .to(".visit-modal", 0.01, { zIndex: 7000, ease: EaselPlugin.easeOut }, 0)
    .to(".visit-modal", 0.3, { opacity: 1, ease: EaselPlugin.easeOut }, 0.01);
});

var modalBtn = document.querySelector(".visit-modal__close");
modalBtn.addEventListener("click", function () {
  var target = new gsap.timeline();
  target
    .to(".visit-modal", 0.2, { opacity: 0, ease: EaselPlugin.easeOut }, 0)
    .to(
      ".visit-modal",
      0.01,
      { zIndex: -100, ease: EaselPlugin.easeOut },
      0.21
    );
});

var modalWrapper = document.querySelector(".visit-modal__blank");
modalWrapper.addEventListener("click", function () {
  document.querySelector(".visit-modal__close").click();
});

window.addEventListener("DOMContentLoaded", () => {
  var ua = window.navigator.userAgent.toLowerCase();

  setTimeout(function () {
    if (!document.body.classList.contains("pace-done")) {
      document.body.classList.add("pace-done");
      document.body.classList.remove("pace-running");
    }
  }, 3000);
});
